<div xmlns="http://www.w3.org/1999/html">

    <mat-expansion-panel class="light-flex-card tv-mat-expansion-indicator-light-bg">
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                Négociations Thématiques
            </mat-panel-title>
        </mat-expansion-panel-header>
        <!-- GUARANTEE -->
        <div class="container" [attr.aria-busy]="isContractThemaNegoBusy">
            <div class="item-all-content">
                <h4 class="guarantee-title">Achat garanti</h4>
                <div class="buttons-container">
                    <button (click)="openThemaPackModal()"
                            [disabled]="isContractThemaNegoBusy"
                            class="tv-round-icon-button-icon-small-light-blue margin">
                        <mat-icon>settings</mat-icon>
                    </button>
                    <button (click)="openThemaNegoModal('guarantee')"
                            [disabled]="isContractThemaNegoBusy"
                            class="tv-round-icon-button-icon-small-light-blue margin">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>

            <!--  INFO : themaNegotiationList[0] always guaranteed negotiation (see in contractItem.model.ts) -->
            <div class="item" *ngFor="let guaranteedNegotiation of themaNegotiationList[0]" [attr.inert]="isContractThemaNegoBusy ? '' : null">
                <div class="item-content">
                    <div class="item-header">
                        <span class="targetId"> {{ guaranteedNegotiation.target.id }} </span>
                        <span class="targetLabel"> {{ guaranteedNegotiation.target.name }} </span>
                        <span class="date-range"> {{ guaranteedNegotiation.startDate }}
                            - {{ guaranteedNegotiation.endDate }} </span>
                        <span class="value"> {{ guaranteedNegotiation.value?.toLocaleString('fr-FR') }} € </span>
                        <span class="nctRate"> {{ guaranteedNegotiation.nctRate }} %</span>
                        <span class="packLabel"> {{ guaranteedNegotiation.contractPack?.label }} </span>
                    </div>
                    <div class="item-actions">
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Modifier la négociation thématique garantie" [disabled]="isContractThemaNegoBusy" (click)="openThemaNegoModal('guarantee', guaranteedNegotiation, false)">
                            <mat-icon svgIcon="edit"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Dupliquer la négociation thématique garantie" [disabled]="isContractThemaNegoBusy" (click)="openThemaNegoModal('guarantee', guaranteedNegotiation, true)">
                            <mat-icon svgIcon="content-copy"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Supprimer la négociation thématique garantie" [disabled]="isContractThemaNegoBusy" (click)="removeThemaNegotiation(guaranteedNegotiation)">
                            <mat-icon class="material-icons-outlined delete-action-icon">delete</mat-icon>
                        </button>
                    </div>
                </div>

                <div class="item-channels-condition">
                    <ng-container *ngFor="let channelCondition of guaranteedNegotiation.channelConditions">
                        <div class="channel-condition-value">
                            <img class="channel-logo" src="{{ channelCondition.channel.logo }}" alt="logo"/>
                            <span>{{ channelCondition.rate || 0 }} %</span>
                        </div>
                    </ng-container>
                </div>

                <div class="conditions-container" *ngIf="guaranteedNegotiation.conditions?.length > 0">
                    <h4 class="conditions-title">Conditions{{ guaranteedNegotiation.conditions[0]?.isInclude === 0 ? ' exclues' : '' }}</h4>
                    <div class="conditions-table-scroll tv-custom-always-visible-scroll-bar">
                    <table mat-table [dataSource]="guaranteedNegotiation.conditions" class="tv-ns-mat-table tv-ns-large-mat-table conditions-table">
                        <ng-container matColumnDef="category">
                            <th mat-header-cell *matHeaderCellDef>Catégorie de négo ({{ conditionCategoryCount(guaranteedNegotiation.conditions) }})</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="condition-cell-text" [attr.title]="row.categoryType?.name">{{ row.categoryType?.name }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Nom ({{ guaranteedNegotiation.conditions.length }})</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="condition-cell-text" [attr.title]="row.categoryValue?.labelCategoryValue">{{ row.categoryValue?.labelCategoryValue }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="number">
                            <th mat-header-cell *matHeaderCellDef>Numéro</th>
                            <td mat-cell *matCellDef="let row">
                                <span class="condition-cell-text" [attr.title]="row.categoryValue?.idCategoryValue">{{ row.categoryValue?.idCategoryValue }}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="conditionColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: conditionColumns"></tr>
                    </table>
                    </div>
                </div>
            </div>
            <div *ngIf="isContractThemaNegoBusy" class="thema-list-loading-overlay" role="status" aria-label="Chargement des négociations thématiques">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </div>

        <br>

        <!-- NOT GUARANTEE -->
        <div class="container" [attr.aria-busy]="isContractThemaNegoBusy">
            <div class="item-all-content">
                <h4 class="guarantee-title">Achat non garanti</h4>
                <button (click)="openThemaNegoModal('notGuarantee')"
                        [disabled]="isContractThemaNegoBusy"
                        class="tv-round-icon-button-icon-small-light-blue margin create-buttons">
                    <mat-icon>add</mat-icon>
                </button>
            </div>

            <!-- INFO : themaNegotiationList[1] always not guaranteed negotiation (see in contractItem.model.ts) -->
            <div class="item item-single-row" *ngFor="let notGuaranteedNegotiation of themaNegotiationList[1]" [attr.inert]="isContractThemaNegoBusy ? '' : null">
                <div class="item-content">
                    <div class="item-header-and-conditions">
                        <div class="item-header">
                            <span class="date-range">{{ notGuaranteedNegotiation.startDate }} - {{ notGuaranteedNegotiation.endDate }}</span>
                            <span class="value">{{ notGuaranteedNegotiation.value?.toLocaleString('fr-FR') }} €</span>
                            <span class="nctRate">{{ notGuaranteedNegotiation.nctRate }} %</span>
                            <span class="channel-condition-value" *ngFor="let channelCondition of notGuaranteedNegotiation.channelConditions">
                                <img class="channel-logo" src="{{ channelCondition.channel.logo }}" alt="logo"/>
                                <span>{{ channelCondition.rate || 0 }} %</span>
                            </span>
                        </div>
                    </div>
                    <div class="item-actions">
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Modifier la négociation thématique non garantie" [disabled]="isContractThemaNegoBusy" (click)="openThemaNegoModal('notGuarantee', notGuaranteedNegotiation, false)">
                            <mat-icon svgIcon="edit"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Dupliquer la négociation thématique non garantie" [disabled]="isContractThemaNegoBusy" (click)="openThemaNegoModal('notGuarantee', notGuaranteedNegotiation, true)">
                            <mat-icon svgIcon="content-copy"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Supprimer la négociation thématique non garantie" [disabled]="isContractThemaNegoBusy" (click)="removeThemaNegotiation(notGuaranteedNegotiation)">
                            <mat-icon class="material-icons-outlined delete-action-icon">delete</mat-icon>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </mat-expansion-panel>

</div>
